import React, { useState, useEffect } from "react";
import DirectorsForm from "./DirectorsForm";
import { useCallbackPrompt } from "../../hooks/useCallbackPrommpt";
import { useDispatch } from "react-redux";
import ConfirmationDialog from "../confirmation-dialog/ConfirmationDialog";
import { resetRegData } from "./directorsRegFormSlice";
import apiService from "../../services/service";
import API_ROUTES from "../../api-routes";
import { useParams } from "react-router-dom";

const UpdateDirectors = () => {
  const [entity, setEntity] = useState({});
  const [showDialog, setShowDialog] = useState(false);
  const [showPrompt, confirmNavigation, cancelNavigation] =
    useCallbackPrompt(showDialog);
  const dispatch = useDispatch();
  const { entityid } = useParams();

  const fetchEntityDetails = async () => {
    const { data } = await apiService(API_ROUTES.FETCH_ENTITY, "GET", {
      replace: { id: entityid },
    });
    setEntity(data);
  };

  const handleConfirmNavigation = () => {
    dispatch(resetRegData());
    confirmNavigation();
  };

  useEffect(() => {
    fetchEntityDetails();
  }, []);

  return (
    <>
      <ConfirmationDialog
        show={showPrompt}
        onConfirm={handleConfirmNavigation}
        onCancel={cancelNavigation}
      />
      <DirectorsForm
        setShowDialog={setShowDialog}
        entityName={entity.name}
        countryCode={entity.country}
      />
    </>
  );
};

export default UpdateDirectors;
